export default __webpack_public_path__ + "static/media/whitelogohor.135e74da.png";